import { inject, Injectable } from '@angular/core';
import { CallbackOnCallNoteWorkflow } from '../models/constant.model';
import { Observable } from 'rxjs';
import {
	CallbackOnCallNoteDTO,
	CallbackOnCallNoteRequestDTO,
} from '../models/callback-on-callnote.model';
import { FeedbackCallnoteDTO, DetailedFeedbackRequestDTO, FeedbackWorkflow } from '../models/feedback.model';
import { CallerCorrectionRequestDTO } from '../models/caller-correction.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class DataService {
	private readonly httpClient: HttpClient = inject(HttpClient);

	fetchCallbackOnCallNote$(
		callbackOnCallNoteWorkflow: CallbackOnCallNoteWorkflow,
	): Observable<CallbackOnCallNoteDTO> {
		const url = `${environment.baseUrl}/document/v1/outboundtasks/callbackoncallnote`;
		return this.httpClient.get<CallbackOnCallNoteDTO>(url, {
			params: { uid: callbackOnCallNoteWorkflow.uid },
		});
	}

	createCallbackOnCallNote$(payload: CallbackOnCallNoteRequestDTO, uid: string): Observable<object> {
		const url = `${environment.baseUrl}/document/v1/outboundtasks/callbackoncallnote`;
		return this.httpClient.post(url, payload, { params: { uid } });
	}

	fetchFeedback$(feedbackWorkflow: FeedbackWorkflow): Observable<FeedbackCallnoteDTO> {
		const url = `${environment.baseUrl}/document/v1/callnotefeedback`;
		return this.httpClient.get<FeedbackCallnoteDTO>(url, {
			params: { uid: feedbackWorkflow.uid },
		});
	}

	saveSimpleRating$(uid: string, rating: number): Observable<FeedbackCallnoteDTO> {
		const url = `${environment.baseUrl}/document/v1/callnotefeedback`;
		return this.httpClient.put<FeedbackCallnoteDTO>(url, { rating }, {
			params: { uid },
		});
	}

	saveDetailedFeedback$(payload: DetailedFeedbackRequestDTO, uid: string): Observable<FeedbackCallnoteDTO> {
		const url = `${environment.baseUrl}/document/v1/callnotefeedback`;
		return this.httpClient.put<FeedbackCallnoteDTO>(url, payload, {
			params: { uid },
		});
	}

	saveCallerCorrection$(uid: string, correction: CallerCorrectionRequestDTO): Observable<CallbackOnCallNoteDTO> {
		// TODO(EB-3382): caller correction not available atm, ongoing BE fix
		const url = `${environment.baseUrl}/document/v1/documents/callnotes`;
		return this.httpClient.put<CallbackOnCallNoteDTO>(url, correction, { params: { uid } });
	}
}
